import * as React from 'react';
import classnames from 'classnames';

interface ButtonProps {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  color?: '' | 'default' | 'white' | 'light' | 'dark' | 'black' | 'text' | 'primary' | 'link' | 'info' | 'success' | 'warning' | 'danger';
  size?: 'small' | 'normal' | 'medium' | 'large';
  isFullwidth?: boolean;
  isOutlined?: boolean;
  isInverted?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isRounded?: boolean;
  onClick?: () => void;
}
const Button: React.SFC<ButtonProps> = (props) => {
  const { 
    type = 'button', 
    children, 
    className = '', 
    color = '',
    size = '',
    isOutlined,
    isFullwidth,
    isInverted,
    isDisabled,
    isRounded,
    onClick
  } = props;
  const btnClassNames = {
    [className]: className,
    [`is-${color}`]: !!color,
    [`is-${size}`]: !!size,
    'is-outlined': isOutlined,
    'is-fullwidth': isFullwidth,
    'is-inverted': isInverted,
    'is-rounded': isRounded
  };
  return (
    <button
      type={type}
      className={classnames('button', btnClassNames)}
      disabled={isDisabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default Button;